import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    info: Object
  },
  watch: {
    visible(newV) {
      if (newV == true) {
        // this.getData();
      }
      this.comparisonVisible = newV;
    },
    info: {
      handler(newV) {
        if (newV.info && newV.tableHead.length) {
          this.getData(newV);
        }
      },
      deep: true
    }
  },
  data() {
    return {
      comparisonVisible: false,
      data: [],
      columns: []
    };
  },
  mounted() {
    if (this.info.info && this.info.tableHead) {
      this.getData(this.info);
    }
  },
  methods: {
    getData(source) {
      this.columns.splice(0);
      this.data.splice(0);
      let planIds = [];
      this.columns = source.tableHead.map(item => {
        let obj = {
          slots: {
            title: item.name
          },
          dataIndex: item.planId,
          key: item.planId,
          align: 'center',
          customRender: text => {
            return text ? text : '-';
          }
        };
        planIds.push(item.planId);
        return obj;
      });
      this.columns.unshift({
        slots: {
          title: '保障权益'
        },
        dataIndex: '1',
        key: '1',
        align: 'center'
      });
      Object.entries(source.info).forEach((item, i) => {
        let obj = {
          1: item[0]
        };
        Object.entries(item[1]).forEach(info => {
          if (planIds.find(p => p == info[0])) {
            obj[info[0]] = info[1];
          }
        });
        this.data.push(obj);
      });
    },
    closeAdd() {
      this.$emit('cancel');
    }
  }
};